// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('discountManagement.discounts.new', {
        url: '/new',
        views: {
            "discountView@discountManagement": {
                templateUrl: 'main/discountManagement/discounts/discount/discount.tpl.html',
                controller: 'DiscountController as vm'
            }
        },
        resolve: {
            discount: function () { return {}; },
            searchTerms: searchTermsResolver,
            discountTypes: discountTypesResolver,
            createNew: function () { return true; },
            createCopy: function () { return false; }
        }
    });

    $stateProvider.state('discountManagement.discounts.discount', {
        url: '/{discountId}',
        views: {
            "discountView@discountManagement": {
                templateUrl: 'main/discountManagement/discounts/discount/discount.tpl.html',
                controller: 'DiscountController as vm'
            }
        },
        resolve: {
            discount: discountResolver,
            searchTerms: searchTermsResolver,
            discountTypes: discountTypesResolver,
            createNew: function () { return false; },
            createCopy: function () { return false; }
        }
    });

    $stateProvider.state('discountManagement.discounts.copy', {
        url: '/copy/{discountId}',
        views: {
            "discountView@discountManagement": {
                templateUrl: 'main/discountManagement/discounts/discount/discount.tpl.html',
                controller: 'DiscountController as vm'
            }
        },
        resolve: {
            discount: discountCopyResolver,
            searchTerms: searchTermsResolver,
            discountTypes: discountTypesResolver,
            createNew: function () { return false; },
            createCopy: function () { return true; }
        }
    });
}
// @ngInject
function discountCopyResolver($stateParams, DiscountsApiService) {
    return DiscountsApiService.getDiscountCopy($stateParams.discountId);
}
// @ngInject
function discountTypesResolver(DiscountsApiService) {
    return DiscountsApiService.getDiscountTypes();
}
// @ngInject
function discountResolver($stateParams, DiscountsApiService) {
    return DiscountsApiService.getDiscount($stateParams.discountId);
}

// @ngInject
function searchTermsResolver($stateParams) {
    return {
        filter: $stateParams.filter ? $stateParams.filter : '',
        showCancelled: $stateParams.canc,
        showApproved: $stateParams.appr,
        showCompleted: $stateParams.comp
    };
}

// @ngInject
function DiscountController($state, discount, discountTypes, loadSpinnerService, DiscountsApiService, createNew, createCopy, $scope, $translate, ToasterService, searchTerms, confirmationDialogService) {
    var vm = this;

    vm.descriptionMaxLength = descriptionMaxLength;
    vm.discount = discount.discount;
    vm.links = discount.links
    vm.discountTypes = discountTypes;
    vm.salesChannels = [];
    vm.mainGroups = [];
    vm.brands = [];
    vm.itemGroups = [];
    vm.isEditing = false;
    vm.isNew = false;
    vm.discountCopy = {};
    vm.step = 1;
    vm.maxSteps = 5;
    vm.itemGroupValidationErrors = [];
    vm.approveDiscount = false;
    vm.filter = '';
    vm.showCancelled = false;
    vm.showApproved= false;
    vm.showCompleted = false;

    vm.brandsChanged = false;
    vm.mainGroupsChanged = false;

    if(searchTerms){
        vm.filter = searchTerms.filter ? searchTerms.filter : '';
        vm.showCancelled = searchTerms.showCancelled ? searchTerms.showCancelled == 'true' ? true : false : false;
        vm.showApproved = searchTerms.showApproved ? searchTerms.showApproved == 'true' ? true : false : false;
        vm.showCompleted = searchTerms.showCompleted ? searchTerms.showCompleted == 'true' ? true : false : false;
    }

    // functions
    vm.save = save;
    vm.enableEditing = enableEditing;
    vm.enableEditingFromCopy = enableEditingFromCopy;
    vm.cancelEditing = cancelEditing;
    vm.delete = deleteDiscount;
    
    vm.isApproveDiscountEnabled = isApproveDiscountEnabled;
    vm.approve = approve;
    vm.cancel = cancel;
    vm.itemGroupsEmpty = itemGroupsEmpty;
    vm.getSalesChannels = getSalesChannels;
    vm.timeSinceLastCall = 0;
    vm.setStepRotation = setStepRotation;
    vm.changeStep = changeStep;
    vm.setStep = setStep;
    vm.transformDiscountPercentToDecimal = transformDiscountPercentToDecimal
    vm.itemGroupStillBlocking = itemGroupStillBlocking;
    vm.validateItemGroups = validateItemGroups;
    vm.isSalesChannelSelected = isSalesChannelSelected;
    vm.endDateLessThanStartDate = endDateLessThanStartDate;
    vm.validatePercentRange = validatePercentRange;
    vm.removeErrorItemGroups = removeErrorItemGroups;
    vm.valueXandYValid = valueXandYValid;

    vm.formatDate = formatDate;

    // links
    vm.canEdit = canEdit;
    vm.canApprove = canApprove;
    vm.canCancel = canCancel;
    vm.canDelete = canDelete;
    vm.claimCanUpdate = claimCanUpdate;
    vm.claimCanCreate = claimCanCreate;
    vm.claimCanDelete = claimCanDelete;

    if (createNew || createCopy) {
        vm.isNew = true;
        vm.isEditing = true;
        
        if(createNew)
            vm.discount = {};

        getSalesChannels();
    }
    
    activate();



    function activate(){
        vm.discount.startDate = new Date(vm.discount.startDate);
        vm.discount.endDate = new Date(vm.discount.endDate);

        transformDiscountPercentToDisplayValue();

        $scope.$watch(function() { 
            if(vm.discount.itemGroups !== undefined)
            {
                return vm.discount.itemGroups.length;
            }

            return vm.discount.itemGroups; 
        
        }, function() {
            if(vm.step === 4){
                validateItemGroups();
            }
        });

        $scope.$watch(function() { 
            if(!_.isUndefined(vm.discount.brands)){
                return vm.discount.brands.length;
            }

            return vm.discount.brands
        }, function() {
            vm.brandsChanged = true;
        });
        
        $scope.$watch(function() { 
            if(!_.isUndefined(vm.discount.mainGroups)){
                return vm.discount.mainGroups.length;
            }

            return vm.discount.mainGroups
        }, function() {
            vm.mainGroupsChanged = true;
        });
    }

    function endDateLessThanStartDate(){
        return vm.discount.endDate <= vm.discount.startDate;
        
    }

    function isSalesChannelSelected(){
        if (vm.discount.salesChannel !== undefined){
            return vm.discount.salesChannel.id > 0
        }
        return false;
    }

    function itemGroupStillBlocking(error){
        var resp = _.findIndex(vm.discount.itemGroups, function(ig) { return ig.id === error.itemGroupId; });
        
        return resp >= 0;
    }

    function transformDiscountPercentToDisplayValue(){
        if(vm.discount.discountPercent !== undefined)
            vm.discount.discountPercent = vm.discount.discountPercent * 100
    }

    function transformDiscountPercentToDecimal(){
        if(vm.discount.discountPercent !== undefined)
            vm.discount.discountPercent = vm.discount.discountPercent * 0.01
    }

    function isApproveDiscountEnabled(){
        var response = true;
        
        response = !itemGroupsEmpty();

        return response;
    }

    function itemGroupsEmpty(){
        var response = false;

        if(_.isUndefined(vm.discount.itemGroups)){
            response = true;
        } else {
            if(vm.discount.itemGroups.length === 0){
                response = true;
            }
        }

        return response;
    }

    function changeStep(increase){
        if(vm.step < vm.maxSteps && increase){
            vm.step++;
        }
        else if(vm.step > 1 && !increase){
            vm.step--;
        }

        getNecessaryData();
    }

    function setStep(stepIndex){
        vm.step = stepIndex;

        if(vm.step > vm.maxSteps){
            vm.step = vm.maxSteps;
        }
        else if(vm.step < 1){
            vm.step = 1;
        }

        getNecessaryData();
    }

    function getNecessaryData(){
        if(vm.step === 2){ //MainGroups
            loadSpinnerService.start('mainSpinner');
            DiscountsApiService.getMainGroups().then(function(result){
                vm.mainGroups = result;
            }, function (error) {
                
            }).finally(function(){
                loadSpinnerService.stop('mainSpinner');
            });
        }
        else if(vm.step === 3){ //Brands
            loadSpinnerService.start('mainSpinner');
            DiscountsApiService.getBrands(vm.discount.mainGroups).then(function(result){
                vm.brands = result;

                // To ensure that no "old" brand is left behind
                var brandIds = [];
                _.forEach(result, function(n){
                    brandIds.push(n.id);
                });
                // Removes brands on the discount object that aren't on the list!
                vm.discount.brands = _.remove(vm.discount.brands, function(brand){
                    return brandIds.includes(brand.id);
                });

            }, function (error) {
                
            }).finally(function(){
                loadSpinnerService.stop('mainSpinner');
            });
        }
        else if(vm.step === 4){ //ItemGroups
            loadSpinnerService.start('mainSpinner');
            vm.itemGroups = [];
            DiscountsApiService.getItemGroups(vm.discount.brands, vm.discount.mainGroups).then(function(result){
                vm.itemGroups = angular.copy(result);
                if(_.isUndefined(vm.discount.itemGroups) || vm.discount.itemGroups.length === 0 || vm.brandsChanged || vm.mainGroupsChanged){
                    vm.brandsChanged = false;
                    vm.mainGroupsChanged = false;
                    vm.discount.itemGroups = angular.copy(result);
                }
            }, function(error){

            }).finally(function(){
                loadSpinnerService.stop('mainSpinner');
                validateItemGroups();
            });
        }
    }

    function validateItemGroups(){
        loadSpinnerService.start('mainSpinner');        
        DiscountsApiService.validateItemGroups(vm.discount.id, vm.discount.itemGroups, vm.discount.startDate, vm.discount.endDate, vm.discount.salesChannel.id).then(function(result){
            vm.itemGroupValidationErrors = result;
        }, function(error){

        }).finally(function(){
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function removeErrorItemGroups(){
        var indexes = [];
        _.forEach(vm.itemGroupValidationErrors, function(error){
            _.forEach(vm.discount.itemGroups, function(itemGroup){
                if(itemGroup.id === error.itemGroupId){
                    indexes.push(vm.discount.itemGroups.indexOf(itemGroup));
                }
            })
        });
        for(var i = indexes.length -1; i >= 0; i--){
            vm.discount.itemGroups.splice(indexes[i], 1);
        }

        validateItemGroups();
    }

    function setStepRotation(){
        var style = {};

        var degrees =  250 + (-35 * (vm.step - 1));

        style['transform'] = 'rotate(' + degrees + 'deg)';

        return style;
    }

    function descriptionMaxLength(maxLength){
        if(vm.discount.description.length > maxLength){
            vm.discount.description = vm.discount.description.substring(0, maxLength);
        }
    }

    function getSalesChannels(){
        DiscountsApiService.getSalesChannels().then(function(result){
            vm.salesChannels = result;
            if(vm.discount.salesChannel != undefined)
                vm.discount.salesChannel = _.find(vm.salesChannels, function(salesChannel){ return salesChannel.id === vm.discount.salesChannel.id});
        }, function (error) {
            
        });
    }

    function formatDate(date) {
        if(date === null)
            return date;
        if(angular.isNumber(date)){
            date = new Date(date);
        }
        const offset = date.getTimezoneOffset()
        date = new Date(date.getTime() - (offset*60*1000))
        return date.toISOString().split('T')[0]
    }

    function save() {
        transformDiscountPercentToDecimal();
        loadSpinnerService.start('mainSpinner');
        DiscountsApiService.saveDiscount(vm.discount).then(function (result) {
            vm.discount.id = result.id.id;
            vm.isEditing = false;
            vm.isNew = false;
            ToasterService.showSuccess('"' + vm.discount.name + '" ' + $translate.instant("common.wasSaved"), $translate.instant("discount.discount"));
            transformDiscountPercentToDisplayValue();
            vm.step = 1;
            if(vm.approveDiscount){
                approve();
            }
            else {
            }
        }, function (error) {
            ToasterService.showError(error.data.message, $translate.instant("discount.discount"), 20000);
            loadSpinnerService.stop('mainSpinner');
        }).finally(function() {
            if(!vm.approveDiscount){
                $state.go('discountManagement.discounts.discount', { discountId: vm.discount.id }, {reload: 'discountManagement.discounts'});
                loadSpinnerService.stop('mainSpinner');
            }
        });
    }

    function approve() {
        confirmationDialogService.showDialog($translate.instant("discount.confirmApprove")).then(function (approveConfirmed) {
            if(approveConfirmed === true) {
                loadSpinnerService.start('mainSpinner');
                DiscountsApiService.approveDiscount(vm.discount.id).then(function (result) {
                    vm.approveDiscount = false;
                    ToasterService.showSuccess($translate.instant("discount.status.approved"), $translate.instant("discount.discount"), 20000);
                }, function (error) {
                    ToasterService.showError(error.data.message, $translate.instant("discount.discount"), 20000);
                }).finally(function() {
                    $state.go('discountManagement.discounts.discount', { discountId: vm.discount.id }, {reload: 'discountManagement.discounts'});
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function cancel(){
        confirmationDialogService.showDialog($translate.instant("discount.confirmCancel"), 'danger').then(function (cancelConfirmed) {
            if(cancelConfirmed === true) {
                loadSpinnerService.start('mainSpinner');
                DiscountsApiService.cancelDiscount(vm.discount.id).then(function(response){
                    ToasterService.showSuccess($translate.instant("discount.status.cancelled"), $translate.instant("discount.discount"), 20000);
                }, function (error) {
                    ToasterService.showError(error.data.message, $translate.instant("discount.discount"), 20000);
                }).finally(function() {
                    $state.go('discountManagement.discounts.discount', { discountId: vm.discount.id }, {reload: 'discountManagement.discounts'});
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function enableEditing() {
        vm.discountCopy = angular.copy(vm.discount);
        vm.discount.startDate = new Date(vm.discount.startDate);
        vm.discount.endDate = new Date(vm.discount.endDate);
        vm.step = 1;
        vm.isEditing = true;
        getSalesChannels();
    }
    
    function enableEditingFromCopy() {
        getSalesChannels();
        $state.go('discountManagement.discounts.copy', {discountId: vm.discount.id});
    }

    function cancelEditing() {
        vm.discount = angular.copy(vm.discountCopy);
        vm.step = 1;
        vm.isEditing = false;
    }

    function deleteDiscount() {
        confirmationDialogService.showDialog($translate.instant("discount.confirmDelete"), 'danger').then(function (deleteConfirmed) {
            if(deleteConfirmed === true) {
                loadSpinnerService.start('mainSpinner');
                DiscountsApiService.deleteDiscount(vm.discount.id).then(function() {
                    ToasterService.showSuccess('"' + vm.discount.name + '" ' + $translate.instant("common.wasDeleted"), $translate.instant("discount.discount"));
                }, function (error) {
                    ToasterService.showError($translate.instant(error.data.message), $translate.instant("discount.discount"));
                }).finally(function () {
                    vm.isEditing = false;
                    vm.isNew = false;
                    vm.step = 1;
                    $state.go('discountManagement.discounts',{},{reload: 'discountManagement.discounts'});
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function validatePercentRange(minValue, maxValue) {
        if(vm.discount.discountPercent < minValue){
            vm.discount.discountPercent = minValue;
        }
        if(vm.discount.discountPercent > maxValue){
            vm.discount.discountPercent = maxValue;
        }

    }

    function valueXandYValid() {
        if(vm.discount.discriminator.value === 'BuyXgetYDiscount'){
            return vm.discount.valueX < vm.discount.valueY && vm.discount.valueX > 0 && vm.discount.valueY > 0
        }
        else if(vm.discount.discriminator.value === 'BuyXgetCheapestDiscount'){
            return vm.discount.valueX > 0
        }
        return true;
    }

    /* DISCOUNT LINKS */
    function canEdit() {
        return DiscountsApiService.canEditDiscount(vm.links);
    }
    function canApprove(){
        return DiscountsApiService.canApproveDiscount(vm.links);
    }
    function canCancel(){
        return DiscountsApiService.canCancelDiscount(vm.links);
    }
    function canDelete(){
        return DiscountsApiService.canDeleteDiscount(vm.links);
    }
    function claimCanUpdate(){
        return DiscountsApiService.claimCanUpdateDiscount(vm.links);
    }
    function claimCanCreate(){
        return DiscountsApiService.claimCanCreateDiscount(vm.links);        
    }
    function claimCanDelete(){
        return DiscountsApiService.claimCanDeleteDiscount(vm.links);        
    }

}

angular
    .module('discounts.discount', [])
    .config(stateConfig)
    .controller('DiscountController', DiscountController);